import { AppTFunction } from '@retail/app/i18n';
import { getISO_8601Date } from '@retail/utils';
import { SupplierItemsExportColumn } from './supplierItemsColumnHeaders';
import { MgSupplierItemSearchResult } from '@retail/products/types';

type AssortmentValueGetter = (
  assortmentItem: MgSupplierItemSearchResult,
  t: AppTFunction
) => string | number | null | undefined;

export const supplierItemsValueMap: Record<SupplierItemsExportColumn, AssortmentValueGetter> = {
  inAssortment: (item, t) => (item.inAssortment ? t('common.yes') : t('common.no')),
  mgItemNumber: (item) => item.mgItemNumber,
  finfoNumber: (item) => item.finfoNumber,
  nobbNumber: (item) => item.nobbNumber,
  primaryText: (item) => item.primaryText,
  secondaryText: (item) => item.secondaryText,
  supplierNumber: (item) => item.mgSupplierId,
  supplierName: (item) => item.participantAccountName,
  productGroupNumber: (item) => item.groupNumber,
  discontinuationDate: (item) =>
    item.discontinuation
      ? getISO_8601Date(new Date(item.discontinuation?.discontinuationDate))
      : '',
  discontinuationStatus: (item) => item.discontinuation?.discontinuationStatus,
};
